/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDobbiesContentBlock contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum actionableRegion {
    imageAndLinks = 'imageAndLinks',
    linksOnly = 'linksOnly'
}

export const enum imagePlacement {
    right = 'right',
    left = 'left'
}

export interface IDobbiesContentBlockConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    headingSettings?: IHeadingSettingsData;
    paragraph?: Msdyn365.RichText;
    image?: Msdyn365.IImageData;
    links?: ILinksData[];
    additionalContent?: IAdditionalContentData[];
    actionableRegion?: actionableRegion;
    imageLink?: Msdyn365.ILinkData;
    imageAriaLabel?: string;
    className?: string;
    clientRender?: boolean;
    isCategoryNameTitle?: boolean;
    imageForMobile?: Msdyn365.IImageData;
    hideClubPlusBanner?: boolean;
    clubPlusTierId?: string;
    imagePlacement?: imagePlacement;
    showCategoryHierarchy?: boolean;
    alreadyPurchasedBoltonsMsg?: string;
    clubPlusPurchasedMsg?: Msdyn365.RichText;
    showManageCookiesModalContentBlock?: boolean;
    shouldShowLoyaltyBoltonDialog?: boolean;
    backgroundColor?: string;
    toggleReadMore?: boolean;
    readMoreCharacterLimit?: number;
}

export interface IDobbiesContentBlockResources {
    readMoreText: string;
    readLessText: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export const enum HeadingSettingsFontWeight {
    Medium500 = 'Medium500',
    Bold700 = 'Bold700'
}

export interface IHeadingSettingsData {
    fontWeight?: HeadingSettingsFontWeight;
    linkUrl?: string;
    underlineOnHover?: boolean;
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IAdditionalContentData {
    heading?: string;
    subtext?: string;
    links?: ILinksData[];
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IDobbiesContentBlockProps<T> extends Msdyn365.IModule<T> {
    resources: IDobbiesContentBlockResources;
    config: IDobbiesContentBlockConfig;
}
